import { SignIn } from "@clerk/clerk-react";
import { Alert, Box, Container, Typography } from "@mui/material";
import React from "react";
import { AllRoutes } from "../../config/routes";

const clerkKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const SignInPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        py: 6,
        backgroundColor: "#f5f5f5",
      }}
    >
      <Container maxWidth="sm" sx={{ display: "flex", justifyContent: "center" }}>
        {clerkKey ? (
          <SignIn
            routing="path"
            path={AllRoutes.SignIn}
            fallbackRedirectUrl={AllRoutes.Projects}
            signUpUrl={undefined}
          />
        ) : (
          <Alert severity="warning">
            <Typography variant="h5" sx={{ mb: 1 }}>
              Clerk is not configured
            </Typography>
            Add `REACT_APP_CLERK_PUBLISHABLE_KEY` and `CLERK_SECRET_KEY` to
            `.env` (see `.env.example`), then restart the app.
          </Alert>
        )}
      </Container>
    </Box>
  );
};

export default SignInPage;
